module.exports = __webpack_public_path__ + "de-header-76b15a.webp";